// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DomUtils = require("../shared/utils/DomUtils.bs.js");
var ReactDom = require("react-dom");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var UserSessionNew = require("../users/UserSessionNew.bs.js");

function decodeProps(json) {
  return [
          Json_decode.field("schoolName", Json_decode.string, json),
          Json_decode.field("fqdn", Json_decode.string, json),
          Json_decode.optional((function (param) {
                  return Json_decode.field("oauthHost", Json_decode.string, param);
                }), json)
        ];
}

var match = decodeProps(DomUtils.parseJSONTag("user-session-new-data", undefined));

var oauthHost = match[2];

var fqdn = match[1];

var schoolName = match[0];

var element = document.querySelector("#user-session-new");

if (!(element == null)) {
  ReactDom.render(React.createElement(UserSessionNew.make, {
            schoolName: schoolName,
            fqdn: fqdn,
            oauthHost: oauthHost
          }), element);
}

exports.decodeProps = decodeProps;
exports.schoolName = schoolName;
exports.fqdn = fqdn;
exports.oauthHost = oauthHost;
/* match Not a pure module */
